module.exports = __webpack_public_path__ + "static/media/merck_terms_of_use_USA.79ab6f6c.pdf";